"use client";
import React, { useEffect, useState } from "react";
import { RiLock2Line, RiLockUnlockLine } from "react-icons/ri";
import { If } from "../Conditional";
import { Switch } from "./Switch";
import { cn } from "~/utils/fontsConfig";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "~/components/shadcn/Tooltip";

export const LockedSwitch = ({
    hasValue,
    tooltip,
    onCheckedChange,
}: {
    hasValue: boolean;
    tooltip?: String;
    onCheckedChange: (checked: boolean) => void;
}) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    useEffect(() => {
        onCheckedChange(isChecked);
    }, [isChecked]);
    return (
        <div className="-mt-2 flex flex-row items-center gap-1">
            <TooltipProvider delayDuration={0}>
                <Tooltip
                    open={isTooltipOpen}
                    onOpenChange={(val) => tooltip && setIsTooltipOpen(val)}
                >
                    <TooltipTrigger>
                        <If condition={isChecked}>
                            <RiLock2Line
                                className={cn(
                                    "text-gray-500",
                                    hasValue && "text-secondary",
                                )}
                            />
                        </If>
                        <If condition={!isChecked}>
                            <RiLockUnlockLine
                                className={cn(
                                    "text-gray-500",
                                    hasValue && "text-secondary",
                                )}
                            />
                        </If>
                    </TooltipTrigger>
                    <TooltipContent sideOffset={-100}>
                        <p className="text-[12px]">{tooltip}</p>
                    </TooltipContent>
                </Tooltip>

                <Switch
                    size="sm"
                    checked={isChecked}
                    onCheckedChange={setIsChecked}
                    aria-readonly
                />
            </TooltipProvider>
        </div>
    );
};
